module.exports = __webpack_public_path__ + "static/img/sciserverlogo.ea67fbb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sciserverlogo.png
// module id = Zcb4
// module chunks = 1